module.exports = __webpack_public_path__ + "media/images/recipes/sakuzyo-c94878ecb86a01ff94cc2354f214460d.png";